import type { BetType } from '../bets/types';

export interface AutoplayLimits {
  singleWinLimit?: number | null;
  balanceIncreaseLimit?: number | null;
  balanceDecreaseLimit?: number | null;
}

export interface AutoplayStartOptions {
  midRound?: boolean;
}

export enum AutoplayStatus {
  /**
   * Autoplay is running
   */
  Running = 'running',
  /**
   * Autoplay is paused but can be resumed with the same settings and maintain the remaining round count.
   */
  Paused = 'paused',
  /**
   * Stopped autoplay. All settings are cleared.
   */
  Stopped = 'stopped',
}

export interface AutoplaySliceType {
  /**
   * Determines the bet amount for which autoplay is running
   */
  activeBetAmount: number;
  isOpen: boolean;
  /**
   * Determines if autoplay is running.
   */
  isInProgress: boolean;
  /**
   * Determines whether a player has been notified about autoplay or not
   */
  isOnboarded: boolean;
  /**
   * Determine whether to indicate autoplay or not
   */
  showIndicator: boolean;
  /**
   * Describes the current autoplay status.
   * Necessary to distinguish paused from stopped autoplay state as the behaviours are different.
   */
  autoplayStatus: AutoplayStatus;
  /**
   * Current bet info that will be used for the autoplay round
   */
  savedBet: BetType | null;
  /**
   * This value represents balance change for autoplay session. Used for limit checks
   */
  balanceChange: number;
  /**
   * The options which user can choose from for autoplay
   */
  roundsOptions: number[];
  /**
   * The additional round increments that can be added to autoplay
   */
  roundsAddons: number[];
  /**
   * Determines the maximum number of rounds allowed for autoplay
   */
  maxRoundsLimit: number;
  roundsLeft: number;
  totalRounds: number;
  singleWinLimit: number | null;
  balanceIncreaseLimit: number | null;
  balanceDecreaseLimit: number | null;
  isLaunchedMidRound: boolean;
  pendingAutoplayBet: boolean;
}
